import { call, take, put, fork, all, select } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { validate } from 'src/utils';
import { fetchJson } from 'src/utils/fetch';
import { commonPay } from 'src/utils/pay';
import { THIRD_PLATFORM_RESOURCECODE } from 'src/utils/staticData';
import { PrescriptionActionTypes } from './type';
// import * as Sentry from "@sentry/browser";

function* fetch_prescription_list() {
  while (true) {
    const action = yield take(PrescriptionActionTypes.FETCH_PRESCRIPTION_LIST);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/prescription/list/page', type: 'POST', data: {
          option: {
            needInquiry: true,
          },
          ...options,
        },
        isloading: true,
        action,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        const { result: { resultList = [], totalPage = 1 } = {} } = res;
        typeof onSuccess === 'function' && onSuccess(result);
        yield put({ type: PrescriptionActionTypes.FETCH_PRESCRIPTION_LIST_SUCCESS, data: resultList, totalPage, currentPage: options.currentPage });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_prescription_list--------' + error.message);
    }
  }
}

function* fetch_prescription_detail() {
  while (true) {
    const action = yield take(PrescriptionActionTypes.FETCH_PRESCRIPTION_DETAIL);
    try {
      yield put({ type: PrescriptionActionTypes.ClEAN_PRESCRIPTION_DETAIL });
      const { prescriptionId } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/prescription/detail', type: 'GET',
        data: { prescriptionId },
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        yield put({ type: PrescriptionActionTypes.FETCH_PRESCRIPTION_DETAIL_SUCCESS, data: { prescriptionImgUrl: '', ...result } });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* fetch_prescription_detail_byInquiryId() {
  while (true) {
    const action = yield take(PrescriptionActionTypes.FETCH_PRESCRIPTION_DETAIL_BYINQUIRYID);
    try {
      yield put({ type: PrescriptionActionTypes.ClEAN_PRESCRIPTION_DETAIL });
      const { inquiryId } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/prescription/detailByInquiryId', type: 'GET',
        data: { inquiryId },
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        yield put({ type: PrescriptionActionTypes.FETCH_PRESCRIPTION_DETAIL_SUCCESS_BYINQUIRYID, data: { prescriptionImgUrl: '', ...result } });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}


function* fetch_order_price() {
  while (true) {
    const action = yield take(PrescriptionActionTypes.FETCH_ORDER_PRICE);
    try {
      const { onSuccess, data } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/preference/calculate',
        type: 'POST',
        data: {
          ...data,
        },
        isloading: true,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        typeof onSuccess === 'function' && onSuccess(result);
        yield put({ type: PrescriptionActionTypes.FETCH_ORDER_PRICE_SUCCESS, data: result });
      } else {

        if (res.code === '100019') {
          typeof onSuccess === 'function' && onSuccess({});
        }
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_prescription_detail--------' + error.message);
    }
  }
}


function* submit_order() {
  while (true) {
    const action = yield take(PrescriptionActionTypes.SUBMIT_ORDER);
    try {
      const { onSuccess, onError } = action;
      const { prescription: { shoppingCart } } = yield select();
      // platformCode 改为从试算接口取
      const { email, mobile, invoiceTitleType, invoiceTitle, taxpayerIdentityNo, ...restData } = shoppingCart;
      const data = {
        ...restData,
        orderGoods: restData.orderGoods.filter((item) => item.goodsNum != 0),
        platformCode: restData.platformCode,
        orderPreferenceList: restData.orderPreferenceList || [],
        orderType: 'drugs',
      };
      if (invoiceTitle) {
        data.orderInvoiceDomain = {
          email,
          mobile,
          invoiceTitle,
          invoiceTitleType,
          taxpayerIdentityNo,
        };
      }
      console.log('submit data', data);
      if([THIRD_PLATFORM_RESOURCECODE.KYUSHU_POP, THIRD_PLATFORM_RESOURCECODE.UNION_DRUG].includes(restData.platformCode) && restData.orderRealAmount !== 0 && validate.isBestpay()){
        StaticToast.error('该药房无法下单，请前往众安互联网医院小程序重新问诊');
      }else{
        const res = yield call(fetchJson, {
          url: '/api/api/v1/patient/order/unifiedOrder',
          type: 'POST',
          data: {
            ...data,
          },
          isloading: true,
          action,
          needToast: !onError,
        });
        if (res && res.code === '0') {
          typeof onSuccess === 'function' && onSuccess();
          const { result: { orderRealAmount = '', orderNo = '', orderTime = '', thirdOrderId = '', platformCode = '', id = '', relatedBizNo = '', servpackBizType = NaN, ...data } = {} } = res;
          commonPay({
            orderRealAmount,
            platformCode,
            thirdOrderId,
            orderTime,
            orderNo,
            id,
            orderType: 'drug',
            relatedBizNo,
            servpackBizType,
            ...data,
          });
        } else {
          typeof onError === 'function' && onError(res);
        }
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

export default function* root() {
  yield all([
    fork(fetch_prescription_detail_byInquiryId),
    fork(fetch_prescription_detail),
    fork(fetch_prescription_list),
    fork(fetch_order_price),
    fork(submit_order),
  ]);
}
